export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11574.2d2c7f98.jpg";